import React, { createContext, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";

import ForgotPassword from '../components/Modals/ForgotPassword';
import ContactForm from '../components/Modals/ContactForm';
import ChangePassword from '../components/Modals/ChangePassword'
import ConfirmChangedPassword from '../components/Modals/PasswordChangeConfirm';
import ThankYouContactUs from '../components/Modals/ThankYouContactUs';
import ThankYouSubscribe from '../components/Modals/ThankYouSubscribe';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {

  const history = useHistory()
  
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isContactUs, setIsContactUs] = useState(false);
  const [isContactUsSubmitted, setIsContactUsSubmitted] = useState(false);
  const [isAppSubscribeSubmitted, setIsAppSubscribeSubmitted] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [isConfirmChangePassword, setIsConfirmChangePassword] = useState(false);
  const [subscribedAppConsent, setSubscribedAppConsent] = useState()

  const openForgotPasswordModal = () => {
    setIsForgotPassword(true);
  }

  const closeForgotPasswordModal = () => {
    setIsForgotPassword(false);
    bodyBodyOverflow();
  }

  const openContactUsModal = () => {
    setIsContactUs(true);
  }

  const closeContactUsModal = () => {
    setIsContactUs(false);
    bodyBodyOverflow();
  }

  const openChangePasswordModal = () => {
    setIsChangePassword(true);
  }

  const closeChangePasswordModal = () => {
    setIsChangePassword(false);
    bodyBodyOverflow();
  }

  const openConfirmChangePasswordModal = () => {
    setIsConfirmChangePassword(true);
    setIsChangePassword(false);
  }

  const closeConfirmChangePasswordModal = () => {
    setIsConfirmChangePassword(false);
    bodyBodyOverflow();
  }

  const openThankYouContactUsModal = () => {
    setIsContactUs(false);
    setIsContactUsSubmitted(true);
  }

  const closeThankYouContactUsModal = () => {
    setIsContactUsSubmitted(false);
    history.push('/')
    bodyBodyOverflow();
  }

  const openThankYouSubscribeModal = (popUpConsent) => {
    setIsAppSubscribeSubmitted(true);
    setSubscribedAppConsent(popUpConsent)
  }

  const closeThankYouSubscribeModal = () => {
    setIsAppSubscribeSubmitted(false);
    bodyBodyOverflow();
  }

  const bodyBodyOverflow = () => {
    document.body.classList.remove('h-screen');
    document.body.classList.remove('overflow-hidden');
  }

  return (
    <ModalContext.Provider value={{ openThankYouContactUsModal, openThankYouSubscribeModal, closeThankYouSubscribeModal, closeThankYouContactUsModal, openForgotPasswordModal, openContactUsModal, closeContactUsModal, openChangePasswordModal, bodyBodyOverflow }}>
      {children}
      {isForgotPassword && (
        <ForgotPassword
          onClose={closeForgotPasswordModal}
        />
      )}

      {isContactUs && (
        <ContactForm
          onClose={closeContactUsModal}
        />
      )}

      {isChangePassword && (
        <ChangePassword
          closeChangePassword={closeChangePasswordModal}
          confirmChangePasswordModal={openConfirmChangePasswordModal}
        />
      )}

      {isConfirmChangePassword && (
        <ConfirmChangedPassword
          closeConfirmChangePassword={closeConfirmChangePasswordModal}
        />
      )}

      {isContactUsSubmitted && (
        <ThankYouContactUs
          onClose={closeThankYouContactUsModal}
        />
      )}

      {isAppSubscribeSubmitted && (
        <ThankYouSubscribe
          onClose={closeThankYouSubscribeModal}
          popUpConsent={subscribedAppConsent}
        />
      )}

    </ModalContext.Provider>
  );
};

// Custom hook to consume the context
export const useModal = () => useContext(ModalContext);
